export default __webpack_public_path__ + "7ba76739ce9cc8132bf3571a6c8672ee.png";